/* Enhanced Image Slider with Vertical Scroll Support
 * This script enhances the image slider to respond to both horizontal and vertical swipes
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log("Enhanced slider script loaded");
  
  // Find all product image sliders
  const productImageSliders = document.querySelectorAll("[id^=\"product-image-slider-\"]");
  
  productImageSliders.forEach(sliderContainer => {
    const slider = sliderContainer.querySelector(".slider-wrapper-clarity");
    if (!slider) return;
    
    const slides = slider.querySelectorAll(".slide-clarity");
    const slideCount = slides.length;
    if (slideCount <= 1) return;
    
    let currentIndex = 0;
    let touchStartX, touchStartY, touchEndX, touchEndY;
    let isSwiping = false;
    
    // Function to go to next slide
    function goToNextSlide() {
      currentIndex = (currentIndex + 1) % slideCount;
      updateSliderPosition();
    }
    
    // Function to go to previous slide
    function goToPrevSlide() {
      currentIndex = (currentIndex - 1 + slideCount) % slideCount;
      updateSliderPosition();
    }
    
    // Function to update slider position
    function updateSliderPosition() {
      slider.style.transform = `translateX(-${currentIndex * 100}%)`;
    }
    
    // Touch start event
    slider.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = true;
    }, { passive: true });
    
    // Touch move event
    slider.addEventListener('touchmove', function(e) {
      if (!isSwiping) return;
      
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
    }, { passive: true });
    
    // Touch end event
    slider.addEventListener('touchend', function(e) {
      if (!isSwiping) return;
      
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      
      // Calculate absolute values for comparison
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);
      
      // Minimum distance required to be considered a swipe
      const minSwipeDistance = 50;
      
      // Handle horizontal swipes
      if (absDeltaX > minSwipeDistance && absDeltaX > absDeltaY) {
        if (deltaX > 0) {
          goToPrevSlide(); // Swipe right
        } else {
          goToNextSlide(); // Swipe left
        }
      }
      // Handle vertical swipes - key new feature
      else if (absDeltaY > minSwipeDistance && absDeltaY > absDeltaX) {
        if (deltaY > 0) {
          goToPrevSlide(); // Swipe down
        } else {
          goToNextSlide(); // Swipe up - as specifically requested
        }
      }
      
      isSwiping = false;
    }, { passive: true });
    
    // Add wheel event for desktop scroll behavior
    slider.addEventListener('wheel', function(e) {
      e.preventDefault();
      
      // Determine scroll direction
      if (e.deltaY > 0) {
        goToNextSlide(); // Scroll down
      } else {
        goToPrevSlide(); // Scroll up
      }
    });
    
    // Add navigation buttons for accessibility
    const prevButton = document.createElement('button');
    prevButton.className = 'slider-nav-button prev-button';
    prevButton.innerHTML = '&lt;';
    prevButton.setAttribute('aria-label', 'Previous slide');
    
    const nextButton = document.createElement('button');
    nextButton.className = 'slider-nav-button next-button';
    nextButton.innerHTML = '&gt;';
    nextButton.setAttribute('aria-label', 'Next slide');
    
    prevButton.addEventListener('click', goToPrevSlide);
    nextButton.addEventListener('click', goToNextSlide);
    
    sliderContainer.appendChild(prevButton);
    sliderContainer.appendChild(nextButton);
    
    // Add slider indicators
    const indicators = document.createElement('div');
    indicators.className = 'slider-indicators';
    
    for (let i = 0; i < slideCount; i++) {
      const indicator = document.createElement('span');
      indicator.className = 'slider-indicator';
      if (i === 0) indicator.classList.add('active');
      
      indicator.addEventListener('click', function() {
        currentIndex = i;
        updateSliderPosition();
        updateIndicators();
      });
      
      indicators.appendChild(indicator);
    }
    
    sliderContainer.appendChild(indicators);
    
    // Function to update indicators
    function updateIndicators() {
      const allIndicators = indicators.querySelectorAll('.slider-indicator');
      allIndicators.forEach((ind, idx) => {
        if (idx === currentIndex) {
          ind.classList.add('active');
        } else {
          ind.classList.remove('active');
        }
      });
    }
    
    // Update indicators when slide changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          updateIndicators();
        }
      });
    });
    
    observer.observe(slider, { attributes: true });
  });
  
  // Add CSS for slider navigation
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    .slider-wrapper-clarity {
      position: relative;
      transition: transform 0.3s ease;
      touch-action: pan-y pinch-zoom;
    }
    
    .slider-nav-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.5);
      color: white;
      border: none;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      opacity: 0.7;
      transition: opacity 0.3s ease;
    }
    
    .slider-nav-button:hover {
      opacity: 1;
    }
    
    .prev-button {
      left: 10px;
    }
    
    .next-button {
      right: 10px;
    }
    
    .slider-indicators {
      position: absolute;
      bottom: 15px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 8px;
      z-index: 10;
    }
    
    .slider-indicator {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.5);
      cursor: pointer;
      transition: background-color 0.3s ease;
    }
    
    .slider-indicator.active {
      background-color: white;
    }
    
    @media (max-width: 767px) {
      .slider-nav-button {
        width: 30px;
        height: 30px;
        font-size: 14px;
      }
      
      .slider-indicators {
        bottom: 10px;
      }
      
      .slider-indicator {
        width: 8px;
        height: 8px;
      }
    }
  `;
  
  document.head.appendChild(styleElement);
});
